<template>
  <div style="display: inline-block;">
    <span @click="show()">
      <slot></slot>
    </span>
    <el-dialog v-if="dialogFormVisible" class="el-dialog-sm bindMobile" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="90%">
      <h3 class="text-center">手机号</h3>
      <el-form ref="form" :model="form" :rules="rules" class="dialog-form">
        <ul class="error-messages" v-if="!isEmptyErrors">
          <li v-for="error in errors">{{error[0].message}}</li>
        </ul>
        <el-form-item prop="mobile">
          <div>
          <div style="width:24%;display:inline-block;vertical-align: middle;" class="areaCode">
            <el-select v-model="form.areaCode" placeholder="区号" @change="selectCode" style="vertical-align: middle;">
              <el-option v-for="(item,index) in reorder" :key="index" :label="'+'+item.key" :value="item.key">
                <span >
                    <div >{{item.value}}</div>
                </span>
              </el-option>
            </el-select>
          </div>
          <div style="width:74%;display:inline-block;vertical-align: middle;">
            <YueDanIpt model="mobile" :object="form" placeholder="手机号"></YueDanIpt>
          </div>
        </div>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item prop="code">
              <YueDanIpt model="code" :object="form" placeholder="验证码">
                <a v-if="!seconds" style="position:absolute;top:4px;right:15px;z-index:99;cursor:pointer;" @click="getCode()">获取验证码</a>
                <a v-if="seconds" style="position:absolute;top:4px;right:15px;z-index:99;cursor:pointer;" >{{seconds}} s</a>
              </YueDanIpt>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6" class="text-center">
            <a v-if="!seconds" @click="getCode()">获取验证码</a>
            <a v-if="seconds">{{seconds}} s</a>
          </el-col> -->
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :loading="loading" class="block" type="primary" @click="submit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import YueDanIpt from '../../../components/YueDanIpt'
import api from '../../../services/api.js'
import {areaCode, phoneReg} from '../../../services/constant.js'

export default {
  name: 'AddAddress',
  props: ['user'],
  components: {
    YueDanIpt: YueDanIpt
  },
  computed: {
    taskInfo () {
	    return this.$store.state.taskInfo
    },
    reorder: function() {
      return this.areaCode.sort(function(x,y){
        return x['value'].localeCompare(y['value'])
      })
    }
  },
  data () {
    return {
      isEmptyErrors: true,
      errors: null,
      areaCode:areaCode,
      phoneReg:phoneReg,
      dialogFormVisible: false,
      loading: false,
      form: {
        mobile: null,
        code: null,
        areaCode:'86'
      },
      mobileReg:/^(\+?0?86\-?)?1[345789]\d{9}$/,
      rules: {
        mobile: [
          { required: true, message: '手机号是必填项', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '验证码是必填项', trigger: 'blur' }
        ]
      },
      seconds: 0
    }
  },
  methods: {
    selectCode(item){
      console.log(item)
      _.each(this.areaCode,list =>{
        if(list.key == item){
          if(list.reg){
            this.mobileReg = this.phoneReg[list.reg]
          }else{
            this.mobileReg = /^[0-9]{0,11}$/
          }
          return false
        }
      })
      console.log(this.mobileReg)
    },
    show () {
      this.isEmptyErrors = true
      this.dialogFormVisible = true
      this.form.mobile = this.user.mobile
    },
    async getCode () {
      if(!this.form.mobile){
        this.isEmptyErrors = false
        this.errors = {
            mobile: [
              {message: '手机号是必填项'}
            ]
          }
        return
      }else if(!(this.mobileReg.test(this.form.mobile))){
        this.isEmptyErrors = false
        this.errors = {
            mobile: [
              {message: '请输入有效的手机号码'}
            ]
          }
        return
      }else{
        this.isEmptyErrors = true
        this.errors = null
      }
      this.$refs['form'].validate(async (valid, errors) => {
        delete errors.code
        this.isEmptyErrors = _.isEmpty(errors)
        this.errors = errors
        if (!errors.mobile) {
          let res = await api.post(this, {
            path: 'buyer.php',
            api: 'send_sms',
            data: {
              mobile: this.form.mobile,
              // mobile_country_code:this.form.areaCode
            }
          })
          this.seconds = 60
          let timer = setInterval(() => {
            this.seconds --
            if (this.seconds == 0) {
              clearInterval(timer)
            }
          }, 1000)
        } else {
          return false
        }
      })
    },
    async submit () {
      this.$refs['form'].validate(async (valid, errors) => {
        this.isEmptyErrors = _.isEmpty(errors)
        this.errors = errors
        if (valid) {
          let res = await api.post(this, {
            path: 'buyer.php',
            api: 'update_mobile',
            data: {
              mobile: this.form.mobile
            }
          })
          this.dialogFormVisible = false
          this.user.mobile = this.form.mobile
        } else {
          return false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
a {
  position: relative;
  top: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/user_center/components/Mobile.vue